export default __webpack_public_path__ + "static/media/za.140aa05d.svg";